import {Component, OnInit, Inject} from '@angular/core';
import {Option} from '../../../core/contracts/models/option';
import {Network} from '../../../core/contracts/models/network';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TypeSocialMediaService } from 'src/app/core/services/api/type-social-media.service';
import { isWhatsAppNetwork, normalizeWhatsAppUser } from 'src/app/core/utils/functions';

@Component({
    selector: 'app-social-networks-form',
    templateUrl: './social-networks-form.component.html',
    styleUrls: ['./social-networks-form.component.scss']
})
export class SocialNetworksFormComponent implements OnInit {


    socialNetwork: Network = {
        idTipoRed: null,
        tipo_red: null,
        red: null
    }
    socialNetworks: Option[] = [];

    title = 'Agregar red social';

    constructor(
        public dialogRef: MatDialogRef<SocialNetworksFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Network,
        private typeSocialMediaService: TypeSocialMediaService
    ) {
        if (data) {
            this.title = 'Editar red social';
            this.socialNetwork.idTipoRed = data.tipo_red.id;
            this.socialNetwork.tipo_red = data.tipo_red;
            this.socialNetwork.red = data.red;
        }
    }

    ngOnInit(): void {
        this.typeSocialMediaService.getAll().subscribe((response: any) => {
            this.socialNetworks = response.data;
        });
    }

    get isWhatsApp(): boolean {
        return isWhatsAppNetwork(this.socialNetworks.find(s => s.id === this.socialNetwork.idTipoRed) as any);
    }

    onSubmit() {
        this.socialNetwork.tipo_red = this.socialNetworks.find(s => s.id === this.socialNetwork.idTipoRed);
        this.socialNetwork.red = this.isWhatsApp
            ? normalizeWhatsAppUser(this.socialNetwork.red)
            : this.socialNetwork.red.replace(/ /g, '');
        this.dialogRef.close({...this.socialNetwork});
    }

    cancel() {
        this.dialogRef.close(this.data);
    }

}
